"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var route_1 = require("./component/route");
exports.Route = route_1.Route;
var route_list_1 = require("./component/route-list");
exports.RouteList = route_list_1.RouteList;
var link_1 = require("./component/link");
exports.Link = link_1.Link;
var router_1 = require("./router");
exports.PATH_START = router_1.PATH_START;
exports.PATH_WILDCARD = router_1.PATH_WILDCARD;
// just for st.enable(router, ...)
exports.router = null;
//# sourceMappingURL=index.js.map